import { useState } from 'react'

import { Button , Checkbox } from '@material-ui/core'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

const ListStock = (props) => {
  const { setFormEdit, data, setIsLoading, empresaId, setData, setRender, edit } = props

  const [loading, setLoading] = useState(true)
  const [listParts, setListParts] = useState([])

  const { state, setClose, setOpen } = SetState()
  //const [ count, setCount ] = useState(0)
  //const [currentPage, setCurrentPage] = useState(0)
  const [checkElement, setCheckElement] = useState([])

  const handleChangeCheckElement = (id) => {
    const selectedPart = listParts.find((part) => part.id === id)

    if (!checkElement.some((item) => item.id === selectedPart.id)) {
      setCheckElement([...checkElement, selectedPart])
    } else {
      setCheckElement(checkElement.filter((item) => item.id !== selectedPart.id))
    }
  }
  const createDismissableSnackbar = useCustomSnackbar()

  async function listProductStock() {
    setIsLoading(true)
    const body = {
      id: data.infoMain.id,
      empresa: empresaId,
    }
    await interfaces.salesOrders
      .listProductStock(body)
      .then((res) => {
        const stock = res.data
        setListParts(stock)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    setIsLoading(false)
  }

  const addProducts = async () => {
    setIsLoading(true)
    for (const item of checkElement) {
      const values = {
        ...item,
        alicuota: Number(data.infoMain.alicuota),
      }
      try {
        const res = await interfaces.salesOrders.addProduct(values)
        setFormEdit((prevRows) => [...prevRows, { ...values }])
        setData((prevData) => ({
          ...prevData,
          productList: [...prevData.productList, { ...values }],
        }))
        createDismissableSnackbar(res.data, { variant: 'success' })
      } catch (error) {
        createDismissableSnackbar('Error al agregar producto', { variant: 'error' })
      }
    }
    setIsLoading(false)
    setRender((prev) => !prev)
    setClose()
  }

  async function handleOpen() {
    //setCurrentPage(0)
    await listProductStock()
    setLoading(false)
    setOpen()
    setCheckElement([])
  }

  // const handleChangePage = async (event, newPage) => {
  //   setCurrentPage(newPage)
  //   await listProductStock(newPage)
  // }

  return (
    <>
      <div
        style={{
          marginTop: '0.5rem',
          position: 'absolute',
          bottom: '7rem',
          width: '97%',
          zIndex: 10,
          backgroundColor: 'white',
          paddingTop: '.5rem',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          color="secondary"
          variant="contained"
          onClick={handleOpen}
          disabled={!edit}
          size="small"
        >
          Agregar
        </Button>
      </div>

      {loading ? (
        ''
      ) : (
        <DialogComponent
          tipo="center"
          open={state.open}
          handleclose={setClose}
          title="Agregar item"
          subtitle="Items correspondientes al pedido original"
          widthLarge="800px"
          maxHeight
          children={
            <div style={{ cursor: edit ? 'pointer' : '' }}>
              <BasicTable
                col={[
                  { title: '', style: { width: '20px' } },
                  { title: 'Descripción', style: { width: '120px' } },
                  { title: 'Código', style: { width: '60px' } },
                  { title: 'Nº de v', style: { width: '80px' } },
                  { title: 'Cantidad', style: { width: '60px' } },
                  { title: 'Precio', style: { width: '100px' } },
                ]}
                size="small"
                rows={listParts.map((row) => {
                  return {
                    seleccionar: (
                      <Checkbox
                        onChange={() => handleChangeCheckElement(row.id)}
                        checked={checkElement.some((item) => item.id === row.id)}
                      />
                    ),
                    producto: row.producto,
                    codigo: row.codigo,
                    nrodev: row.nrodev,
                    cantidad: row.cantidad,
                    precio: `$${Number(row.precio).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                  }
                })}
              />
            </div>
          }
          actions={
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                marginRight: '15px',
              }}
            >
              <Button onClick={setClose}>Cancelar</Button>
              <Button
                onClick={addProducts}
                color="primary"
                variant="contained"
                disabled={checkElement.length === 0}
              >
                Seleccionar
              </Button>
            </div>
          }
        />
      )}
    </>
  )
}

export default ListStock
